import React, { useEffect, useState, useContext } from "react";
import { ApiService } from "../../Component/services/apiServices";
import DataContext from "../../Component/context";
import { Alert } from "react-bootstrap";
import AccountHeader from "../../Component/Header/account_header";

function Profile() {
  const contextValues = useContext(DataContext)
  const [successmsg, setsuccessmsg] = useState("");
  const [errormsg, seterrormessage] = useState("");
  const [isLoading, setisLoading] = useState(false);

  const handleUpdateInput = (e) => {
    seterrormessage("");
    const { name, value } = e.target;
    contextValues.setUserData({
      ...contextValues.UserData,
      [name]: value,
    });
  };

  const Profileupdate = (e) => {
    e.preventDefault();
    if (contextValues.UserData?.user_name === "" || contextValues.UserData?.user_name === null) {
      seterrormessage('error', "Please enter full name");
      return;
    }
    setisLoading(true);
    const dataString = {
      user_id: contextValues.UserData?.user_id,
      user_name: contextValues.UserData?.user_name,
    };
    ApiService
      .postData('profile-update', dataString)
      .then((res) => {
        if (res?.status === "success") {
          setisLoading(false);
          contextValues.setUserData(res?.userData)
          setsuccessmsg(res.message)
          setTimeout(() => {
            setsuccessmsg('')
          }, 500)
        } else if (res.status === 'session_expired') {
          localStorage.removeItem('USER_TOKEN')
          window.location.href = '/'
        } else {
          seterrormessage(res.message)
          setisLoading(false);
        }
      });
  };

  return (
    <>
      <AccountHeader heading={'My Profile'}></AccountHeader>
      <div id="appCapsule">
      <div className="mwapper">
        <div className="p-3">
          <div className="row">
            <div className="col-lg-12">
              {errormsg && (<Alert variant="danger">{errormsg}</Alert>)}
              {successmsg && <Alert variant="success">{successmsg}</Alert>}
            </div>
            <div className="col-lg-12">
              <div className="form-group mb-3">
                <label htmlFor="user_fname">Full Name</label>
                <input
                  type="text"
                  defaultValue={contextValues.UserData?.user_name}
                  placeholder="Full Name"
                  name="user_name"
                  onChange={(e) => {
                    handleUpdateInput(e);
                  }}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="form-group mb-3">
                <label htmlFor="user_email" className="form-label">
                  Email Address
                </label>
                <input
                  type="email"
                  name="user_email"
                  className="form-control required"
                  placeholder="Email Address"
                  value={contextValues.UserData?.user_email}
                  disabled={true}
                  readOnly={true}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="form-group mb-3">
                <label htmlFor="user_mobile" className="form-label">
                  Mobile Number
                </label>
                <input
                  type="number"
                  name="user_mobile"
                  className="form-control required"
                  placeholder="Mobile Number"
                  value={contextValues.UserData?.user_mobile}
                  disabled={true}
                  readOnly={true}
                />
              </div>
            </div>
            <div className="ccpanel-footer">
              <button
                className="btn btn-primary btn-full btn-lg mt-10"
                type="button"
                name="submit"
                onClick={(e) => {
                  Profileupdate(e);
                }}
                disabled={isLoading}
              >
                {isLoading ? (
                  <img src="/img/loder01.gif" width="60px" height="11px" alt="Daadi's Kitchen" />
                ) : (
                  "Update"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      </div>
     
    </>
  );
}
export default Profile;
